module.exports = __webpack_public_path__ + "static/media/google_white.625ee969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Badges/medias/google_white.svg
// module id = 161
// module chunks = 0